module.exports = __webpack_public_path__ + "static/media/shift_app_ios.184049b1.webp";